import * as actionTypes from './actionTypes';

const initialState = {
	isLoading: false,
	error: null,
	data: [],
};

const AssociatedDataList = (state = initialState, action) => {
	//eslint-disable-line complexity
	switch (action.type) {
		case actionTypes.ASSOCIATED_DATA_LIST_FETCH_FOR_DATASET_ID:
			switch (action.status) {
				case 'pending':
					return {...state, isLoading: true};
				case 'success':
					return {
						...state,
						data: action.associatedDataList,
						isLoading: false,
					};
				case 'error':
					return {...state, error: action.msg, isLoading: false};
				default:
					return state;
			}
		case actionTypes.ASSOCIATED_DATA_DELETE_BY_ID:
			switch (action.status) {
				case 'pending':
					return {...state, isLoading: true};
				case 'success':
					return {
						...state,
						isLoading: false,
					};
				case 'error':
					return {...state, error: action.msg, isLoading: false};
				default:
					return state;
			}

		default:
			return state;
	}
};

export default AssociatedDataList;
